import React, { useMemo } from 'react';
import './HeroNetworkBackground.css';

const HeroNetworkBackground = () => {
    // Generate stable random nodes
    const nodes = useMemo(() => {
        const points = [];
        const count = 40; // Number of nodes

        for (let i = 0; i < count; i++) {
            points.push({
                x: Math.random() * 100,
                y: Math.random() * 100,
                r: Math.random() * 2 + 1, // radius
                id: i
            });
        }
        return points;
    }, []);

    // Generate connections (lines) between close nodes
    const links = useMemo(() => {
        const connections = [];
        nodes.forEach((nodeA, i) => {
            nodes.slice(i + 1).forEach((nodeB) => {
                const dx = nodeA.x - nodeB.x;
                const dy = nodeA.y - nodeB.y;
                const distance = Math.sqrt(dx * dx + dy * dy);

                // Connect if close enough (e.g., within 20% of screen width/height)
                if (distance < 20) {
                    connections.push({
                        x1: nodeA.x,
                        y1: nodeA.y,
                        x2: nodeB.x,
                        y2: nodeB.y,
                        opacity: 1 - distance / 20 // Fade out distant lines
                    });
                }
            });
        });
        return connections;
    }, [nodes]);

    return (
        <div className="hero-network-bg">
            <svg className="network-svg" viewBox="0 0 100 100" preserveAspectRatio="none">

                {/* Render Links */}
                <g className="network-links">
                    {links.map((link, i) => (
                        <line
                            key={`link-${i}`}
                            x1={`${link.x1}%`}
                            y1={`${link.y1}%`}
                            x2={`${link.x2}%`}
                            y2={`${link.y2}%`}
                            stroke="#a78bfa"
                            strokeWidth="0.1"
                            strokeOpacity={link.opacity * 0.4}
                        />
                    ))}
                </g>

                {/* Render Nodes */}
                <g className="network-nodes">
                    {nodes.map((node, i) => (
                        <circle
                            key={`node-${i}`}
                            cx={`${node.x}%`}
                            cy={`${node.y}%`}
                            r={node.r * 0.15}
                            fill="#c4b5fd"
                            fillOpacity="0.6"
                        />
                    ))}
                </g>
            </svg>
        </div>
    );
};

export default HeroNetworkBackground;
